export default __webpack_public_path__ + "static/media/Broadway psoter.821d7b36.jpg";